import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './spinner.css';

const Spinner = props => {
  return (
    <div className={cx('spinner-container', { active: props.show })}>
      <div className="spinner-content">{props.children}</div>
      {props.show && (
        <div>
          <div className="spinner-backdrop" />
          <div className="spinner-outer">
            <div className="spinner" />
          </div>
        </div>
      )}
    </div>
  );
};

Spinner.defaultProps = {
  show: false,
};

Spinner.propTypes = {
  show: PropTypes.bool,
  children: PropTypes.node,
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/ui/src/component/spinner/spinner.js